module.exports = __webpack_public_path__ + "img/91159.c63128c7.svg";